/**
 * The page the person was on before they opened Support, so a request can say
 * "it happened on /finance" without asking. Kept in memory only (a reload clears
 * it and the request simply carries no page). AppRouter calls `rememberSupportPage`
 * on every navigation; nothing else writes here.
 */
let lastPage = "";

export function rememberSupportPage(pathname: string): void {
  if (!pathname.startsWith("/support")) lastPage = pathname;
}

export function lastPageBeforeSupport(): string {
  return lastPage;
}
